/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";

/* Styles */
import styles from "./styles";

const TravelCreditsWelcomeModal = ({ showTravelCreditsWelcomeModal, setShowTravelCreditsWelcomeModal }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
      <UCModal
        className={classes.travelCreditsWelcomeModal}
        showModal={ showTravelCreditsWelcomeModal }
        setShowModal={ setShowTravelCreditsWelcomeModal }
        hideCloseButton
        keepOnBackdrop
        modalContent={ <Content setShowModal={ setShowTravelCreditsWelcomeModal }/> }
        dataTestId="travelCreditsWelcomeModal"
      />
  )
}

export default TravelCreditsWelcomeModal;